"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var createLocalComputerFiles_1 = require("./utils/createLocalComputerFiles");
exports.createLocalComputerFiles = createLocalComputerFiles_1.default;
var createMailItemFiles_1 = require("./utils/createMailItemFiles");
exports.createMailItemFiles = createMailItemFiles_1.default;
var createUriFiles_1 = require("./utils/createUriFiles");
exports.createUriFiles = createUriFiles_1.default;
//# sourceMappingURL=lazyIndex.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/attachments/owa-attachment-common/lib/lazyIndex.js
// module id = 2971
// module chunks = 100